<template>
    <div class="camp-segrow">
        <div class="flex items-baseline justify-between gap-3">
            <span class="body-small text-valence-stone-900">{{ label }}</span>
            <span class="details text-valence-stone-500 shrink-0">{{ avg !== null ? avg.toFixed(2) : "—" }}</span>
        </div>
        <div v-if="total > 0" class="camp-seg">
            <span
                v-for="(count, i) in distribution"
                :key="i"
                class="camp-seg__part"
                :class="{ 'camp-seg__part--dark': isLightSwatch(i) }"
                :style="{ width: `${percent(count)}%`, background: SEGMENT_COLORS[i] }">
                <template v-if="percent(count) >= 8">{{ percent(count) }}%</template>
            </span>
        </div>
        <div v-else class="details text-valence-stone-500">No responses yet.</div>
    </div>
</template>

<script setup lang="ts">
import { LIGHT_SWATCH_INDICES, SEGMENT_COLORS } from "~vue/pages/reflections/campPalette";
import { computed } from "vue";

interface Props {
    label: string;
    // Distribution buckets: [rarely, occasionally, sometimes, often, consistently].
    distribution: number[];
    avg: number | null;
}

const props = defineProps<Props>();

const total = computed(() => props.distribution.reduce((sum, n) => sum + n, 0));

function percent(count: number): number {
    if (!total.value) {
        return 0;
    }
    return Math.round((count / total.value) * 100);
}

function isLightSwatch(index: number): boolean {
    return LIGHT_SWATCH_INDICES.has(index);
}
</script>

<style scoped>
.camp-segrow {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.camp-seg {
    display: flex;
    width: 100%;
    height: 30px;
    border-radius: 10px;
    overflow: hidden;
}

.camp-seg__part {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: var(--font-scaffold, sans-serif);
    font-size: 12px;
    line-height: 18px;
    color: #f7f5f2;
    min-width: 0;
}

.camp-seg__part--dark {
    color: #37322b;
}
</style>
